<form>
  <!-- Modal Header -->
  <div class="modal-header">
    @if (request != undefined) {
      <h4 class="modal-title">{{ request.CustomerName }} ({{ sharedService.processICNum(request.CustomerIC) }})</h4>
    }
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <div class="container-fluid p-0">
      @if (requestList != undefined) {
        @for (request of requestList; track request) {
          <app-loan-request-details [request]="request" [isExpanded]="true" [onlyViewLoan]="true"></app-loan-request-details>
        }
      }

      @if (request != undefined) {
        <app-loan-request-details [request]="request" [isExpanded]="true" [onlyViewLoan]="onlyViewLoan"></app-loan-request-details>
      }
    </div>
  </div>

  @if (request != undefined && request.AuthorizedBy == undefined && sharedService.isBranchManager() == true) {
    <div class="modal-footer">
      <button class="btn btn-outline-success" type="button" (click)="confirmBeforeAction()" [disabled]="disabledSubmit">Authorize</button>
    </div>
  }
</form>
